import React from 'react';
import { CheckCircle2, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
const items = [{
  title: '01 — Manual Fundamental de Tarot Terapéutico',
  description: 'Estructura completa para comprender el tarot terapéutico desde sus bases y aplicarlo con claridad profesional.'
}, {
  title: '02 — Sistema Profesional de Interpretación Terapéutica',
  description: 'Método guiado para interpretar cartas con profundidad emocional y acompañamiento consciente.'
}, {
  title: '03 — Biblioteca de 200 Preguntas de Exploración Emocional',
  description: 'Preguntas listas para desbloquear conversaciones profundas y generar sesiones más transformadoras.'
}, {
  title: '04 — Métodos de Tiradas Terapéuticas',
  description: 'Diferentes estructuras de lectura para acompañar procesos emocionales, vínculos y decisiones importantes.'
}, {
  title: '05 — Fichas de Anamnesis y Evaluación Terapéutica',
  description: 'Herramientas organizadas para registrar sesiones, evolución emocional y seguimiento de consultantes.'
}, {
  title: '06 — Diario de Interpretación y Evolución Personal',
  description: 'Espacio guiado para desarrollar intuición, observación y crecimiento terapéutico progresivo.'
}, {
  title: '07 — Guía práctica de lectura + Cartas Rider Waite',
  description: 'Manual práctico para interpretar símbolos, arcanos y conexiones entre cartas paso a paso.'
}, {
  title: '08 — Sistema de Seguimiento Terapéutico para Consultantes',
  description: 'Método profesional para acompañar procesos emocionales y dar continuidad a cada sesión.'
}];
export function WhatYouReceive() {
  return <section className="py-24 bg-transparent relative overflow-hidden pt-[30px] pb-[30px]" data-id="element-316">
      <div className="max-container px-4 relative z-10 pr-[16px]" data-id="element-317">
        <div className="text-center mb-20" data-id="element-318">
          <h2 className="text-5xl md:text-7xl font-bold text-purple-950 font-magical italic mb-[24px]" data-id="element-319">
            ¿Qué vas a <span className="text-purple-600" data-id="element-320">Recibir?</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-321">
          {items.map((item, i) => <motion.div key={i} whileHover={{
          y: -5
        }} className="bg-white p-8 rounded-[2.5rem] border border-purple-100 shadow-xl premium-shadow pt-[32px] pb-[32px]" data-id="element-322">
              <div className="w-16 h-16 bg-purple-50 rounded-2xl flex items-center justify-center text-purple-600 mb-6" data-id="element-323">
                <CheckCircle2 size={32} data-id="element-324" />
              </div>
              <h3 className="text-2xl font-bold text-purple-950 mb-4 font-magical italic" data-id="element-325">
                {item.title}
              </h3>
              <p className="text-zinc-600 leading-relaxed" data-id="element-326">
                {item.description}
              </p>
            </motion.div>)}
        </div>

        <div className="mt-16 p-8 rounded-[2.5rem] bg-gradient-to-br from-blue-900 to-blue-950 text-white text-center shadow-2xl border border-white/10" data-id="element-327">
          <p className="text-xl md:text-2xl font-medium italic" data-id="element-328">
            "No es solo una guía, es el mapa terapéutico para profundizar en tu
            intuición y potenciar tu mirada como profesional del Tarot."
          </p>
        </div>
      </div>
    </section>;
}